import { YELLOW_COMPONENTS } from "./yellowRegistry";
import { GREEN_COMPONENTS } from "./greenRegistry";
import { ACCESS_COMPONENTS } from "./accessRegistry";

export const PROGRAM_REGISTRIES = {
  yellow: () => import("./yellowRegistry").then((m) => m.YELLOW_COMPONENTS),
  green: () => import("./greenRegistry").then((m) => m.GREEN_COMPONENTS),
  access: () => import("./accessRegistry").then((m) => m.ACCESS_COMPONENTS),
} as const;

export const ALL_COMPONENTS = {
  ...YELLOW_COMPONENTS,
  ...GREEN_COMPONENTS,
  ...ACCESS_COMPONENTS,
} as const;

export const CONFIG_REGISTRY = {
  yellow: () => import("../config/yellowConfig.json"),
  green: () => import("../config/greenConfig.json"),
  access: () => import("../config/accessConfig.json"),
} as const;

export type ProgramKey = keyof typeof PROGRAM_REGISTRIES;
export type ComponentPath = keyof typeof ALL_COMPONENTS;
